module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp13-2be66194bc64bc91da54f8ab70d5e4db.jpg";